import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../ui';
import { Fill } from '../../../ui/Fill';
import { FlexScroller } from '../../../ui/Scrollers';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { AccountSlice } from './AccountSlice';
import { AdvertSlice } from './AdvertSlice';
import { MainMenuSlice } from './MainMenuSlice';
import { ReadonlySlice } from './ReadonlySlice';

const Frame = styled(Fill)`
    z-index: 50;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    /* color: ${Colors.primaryText}; */
    /* background: #FFF;
    box-shadow: 0 1px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06); */
    /* border-top: solid 1px #F0F2F5; */
`;

const Drop = styled.div`
    margin-top: auto;
`;

export const NavigationView = () => {
    // NavigationScope is at a higher level (near AppScope).  It should be here, but it will reload each page change at the moment and I
    // don't have the time to figure out how to stop that.
    return <Flexer inset flex="column">
        <Flexer flex grow>
            <FlexScroller>
                <Flexer inset flex="column">
                    <MainMenuSlice />
                    <Drop>
                        <ReadonlySlice />
                        <AdvertSlice />
                    </Drop>
                </Flexer>
            </FlexScroller>
        </Flexer>
        <Flexer shrink>
            <AccountSlice />
        </Flexer>
    </Flexer>;
};
